import { render } from "./Modal.vue?vue&type=template&id=535101be&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=535101be&scoped=true&lang=scss"

import exportComponent from "/Users/lolo/projects/mygpsworkouts-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535101be"]])

export default __exports__